"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const rsuite_1 = require("rsuite");
exports.Footer = (props) => {
    const { components, searchQuery, handlePageChange } = props;
    // Full overwrite
    if (components && components.Footer) {
        return react_1.default.createElement(components.Footer, Object.assign({}, props));
    }
    const { page = 0 } = searchQuery;
    const onSelect = (newPage) => handlePageChange(newPage);
    return (react_1.default.createElement("div", { style: { textAlign: 'center' } },
        react_1.default.createElement(rsuite_1.Pagination, { next: true, prev: true, size: "lg", pages: 10, activePage: page + 1, onSelect: onSelect })));
};
//# sourceMappingURL=Footer.js.map